import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import colors from 'src/utils/colors';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { Divider, IconButton } from '@mui/material';
import { PresentationType } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Type/PresentationsTypePage';
import { SlPill } from 'src/components/BeaconV2Components/SlPill';
import { BlueInfo } from 'src/components/SvgIcons/SvgIcons';
import { FormValue } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/types';

interface TypeCardProps {
  type: PresentationType;
  isSelected?: boolean;
  onSelect: (type: FormValue) => void;
  disabled?: boolean;
}

export const TypeCard: React.FC<TypeCardProps> = ({ type, isSelected, onSelect, disabled }) => {
  const Pill = ({ text }) => (
    <SlPill
      sx={{
        backgroundColor: '#F2F4F6',
        borderRadius: '4px',
        border: 'none',
        height: 'auto',
        cursor: 'default',
        padding: '4px 8px'
      }}
    >
      <Text variant="body3" fontWeight="500" sx={{ color: colors.grey }}>
        {text}
      </Text>
    </SlPill>
  );

  return (
    <Flex
      gap={16}
      flexDirection="column"
      sx={{
        border: `1px solid`,
        borderColor: isSelected ? colors.actualSpend : colors.graysSecondary,
        borderRadius: '8px',
        boxSizing: 'content-box',
        padding: '16px',
        lineHeight: '18px'
      }}
    >
      <Flex flexDirection="column" gap={8}>
        <Flex alignItems="center" justifyContent="space-between">
          <Text variant="h4" sx={{ fontSize: '16px' }}>
            {type.label}
          </Text>
        </Flex>
        <Text variant="body2" lineHeight="20px">
          {type.description}
        </Text>
      </Flex>
      <Flex gap={8}>
        {type?.status === 'COMING_SOON' ? <Pill text="Coming soon" /> : type.tags?.map((tag) => <Pill key={tag} text={tag} />)}
      </Flex>
      <Divider />
      <Flex justifyContent="space-between" alignItems="center">
        {type?.status === 'COMING_SOON' ? (
          <Text variant="body3" sx={{ color: colors.grey, lineHeight: '24px' }}>
            More details on the way
          </Text>
        ) : (
          <>
            <Text variant="body3" sx={{ color: colors.grey, lineHeight: '24px' }}>
              {type.totalSections} sections | {type.totalSlides} slides
            </Text>
            <SlButton
              buttonSx={{
                borderRadius: '16px',
                padding: '3px 20px',
                height: '24px',
                backgroundColor: 'transparent',
                color: colors.darkBlue,
                borderColor: colors.graysSecondary,
                '&:hover': { backgroundColor: colors.darkBlue, borderColor: colors.darkBlue, color: colors.white }
              }}
              textSx={{
                fontSize: '12px',
                lineHeight: '18px',
                color: 'inherit',
              }}
                onClick={() => onSelect({ id: type.id, name: type.label })}
                disabled={disabled}
            >
              Create
            </SlButton>
          </>
        )}
      </Flex>
    </Flex>
  );
};
